import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withKeys as _withKeys, vShow as _vShow, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91735e74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_content_container",
  class: "container-fluid"
}
const _hoisted_2 = { class: "row p-5" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-stack mt-1 mb-1" }
const _hoisted_4 = { class: "d-flex my-2" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative me-4" }
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Tìm kiếm ")
const _hoisted_8 = { class: "g-6 g-xl-9 mt-1 mb-1" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = {
  key: 0,
  class: "p-5 m-0 fs-5"
}
const _hoisted_11 = {
  key: 1,
  class: "p-5 m-0 fs-5"
}
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { class: "f-flex" }
const _hoisted_14 = { class: "breadcrumb fw-bold fs-7 my-1" }
const _hoisted_15 = { class: "breadcrumb-item text-muted" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  href: "#",
  class: "text-hover-primary"
}
const _hoisted_18 = {
  class: "row g-6 g-xl-9 mb-6 mb-xl-9 scroll-component",
  ref: "scrollComponent"
}
const _hoisted_19 = {
  key: 0,
  class: "card h-100"
}
const _hoisted_20 = { class: "position-relative card-body d-flex justify-content-center text-center flex-column p-0 item-media" }
const _hoisted_21 = { class: "media-action position-relative w-100" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-3" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil fs-3" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "text-gray-800 d-flex flex-column" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-folder-fill" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "fs-6 fw-bolder mb-2 p-2 position-relative" }
const _hoisted_33 = ["onUpdate:modelValue", "onKeyup"]
const _hoisted_34 = {
  key: 1,
  class: "w-100 fs-6 fw-bold"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check fs-3" }, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "fs-7 fw-bold text-gray-400 mb-2" }
const _hoisted_39 = {
  key: 1,
  class: "card h-100"
}
const _hoisted_40 = {
  key: 0,
  class: "multi-selectple"
}
const _hoisted_41 = { class: "form-check border border-2 border-primary border-blue-dx rounded form-check-custom form-check-solid" }
const _hoisted_42 = ["value"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  href: "#",
  class: "text-gray-800 text-hover-primary d-flex flex-column"
}
const _hoisted_45 = { class: "symbol mb-5 symbol-150px symbol-2by3" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "fs-6 fw-bolder mb-2 p-2" }
const _hoisted_48 = { class: "fs-7 fw-bold text-gray-400 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              id: "kt_filter_search",
              class: "form-control form-control-solid form-control-sm w-150px ps-9",
              placeholder: "Tìm kiếm"
            }, null, 512), [
              [_vModelText, _ctx.search]
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-primary ms-1 me-3 ms-1",
            "data-kt-menu-trigger": "click",
            "data-kt-menu-placement": "bottom-end",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch()))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen004.svg" }),
              _hoisted_7
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _mergeProps(_ctx.getRootProps(), { class: "mt-5 px-7 py-3 border border-dashed border-gray-300 rounded bg-light-primary bg-hover-success text-hover-inverse-info text-center" }), [
            _createElementVNode("input", _mergeProps(_ctx.getInputProps(), { accept: "image/x-png,image/gif,image/jpeg" }), null, 16),
            (_ctx.isDragActive)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Thả ảnh để upload ... "))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, " Kéo thả ảnh hoặc nhấp chuột để đăng "))
          ], 16)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary bg-blue-dx btn-sm my-3",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createNewFolder())),
          "data-bs-toggle": "tooltip",
          title: "",
          "data-bs-original-title": "Coming soon"
        }, " New Folder ")
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("ul", _hoisted_14, [
          _createElementVNode("li", _hoisted_15, [
            _createElementVNode("span", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.rootFolder())),
              class: "text-muted text-hover-primary"
            }, "Home")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbData, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "breadcrumb-item text-muted",
              onClick: ($event: any) => (_ctx.clickBreadcrumb(index)),
              key: index
            }, [
              _createElementVNode("a", _hoisted_17, _toDisplayString(item.originalname), 1)
            ], 8, _hoisted_16))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataMedia, (image, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-md-6 col-lg-3 col-xl-2",
          key: index
        }, [
          (image.mimetype === 'folder')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      class: "btn btn-sm-media btn-icon btn-danger top-3px position-absolute l-100",
                      onClick: ($event: any) => (_ctx.deleteMedia(image._id, index))
                    }, _hoisted_24, 8, _hoisted_22),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.showEditTitle[index] = true),
                      class: "btn btn-sm-media btn-icon btn-primary top-10 position-absolute l-100"
                    }, _hoisted_27, 8, _hoisted_25)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.openFolder(image)),
                      class: "symbol mb-5 media-folder symbol-150px symbol-2by3 cursor-pointer"
                    }, _hoisted_31, 8, _hoisted_29),
                    _createElementVNode("div", _hoisted_32, [
                      (_ctx.showEditTitle[index])
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            class: "w-100 form-control-sm form-control fs-6 fw-bold text-center folder",
                            contenteditable: "true",
                            "onUpdate:modelValue": ($event: any) => ((image.originalname) = $event),
                            onKeyup: _withKeys(($event: any) => (_ctx.updateMedia(image, index)), ["enter"])
                          }, null, 40, _hoisted_33)), [
                            [_vModelText, image.originalname]
                          ])
                        : (_openBlock(), _createElementBlock("h4", _hoisted_34, _toDisplayString(image.originalname), 1)),
                      _withDirectives(_createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.updateMedia(image, index)),
                        class: "btn btn-sm btn-icon btn-success btn-sm-media-check top-0 position-absolute l-100"
                      }, _hoisted_37, 8, _hoisted_35), [
                        [_vShow, _ctx.showEditTitle[index]]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(image.created_at), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                (_ctx.isMultiple)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("label", _hoisted_41, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input h-20px w-20px",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectMultipleMedia) = $event)),
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeSelectMultiple($event))),
                          value: { name: image.image.name, path: image.image.path }
                        }, null, 40, _hoisted_42), [
                          [_vModelCheckbox, _ctx.selectMultipleMedia]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "card-body d-flex justify-content-center text-center flex-column p-0",
                  onClick: ($event: any) => (
              _ctx.selectImage({
                name: image.name,
                path: image.path,
                width: image?.width,
                height: image?.height,
              })
            )
                }, [
                  _createElementVNode("a", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("img", {
                        src: _ctx.renderImageUrl(image, 'small'),
                        alt: "",
                        class: "",
                        style: {"object-fit":"cover","width":"100%"}
                      }, null, 8, _hoisted_46)
                    ]),
                    _createElementVNode("div", _hoisted_47, _toDisplayString(image.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_48, _toDisplayString(image.created_at), 1)
                ], 8, _hoisted_43)
              ]))
        ]))
      }), 128))
    ], 512),
    (_ctx.isMultiple && _ctx.selectMultipleMedia.length > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          id: "onSelectMultiple",
          class: "btn btn-success",
          type: "button",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSelectMultiple()))
        }, " Chọn Ảnh "))
      : _createCommentVNode("", true)
  ]))
}